module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



//////////////////
// WEBPACK FOOTER
// /Users/yinminpan/Local Dev/business-events-tas/wp-content/themes/b-e-tas/node_modules/es-to-primitive/helpers/isPrimitive.js
// module id = 136
// module chunks = 0